// extracted by css-extract-rspack-plugin
var _1 = "NhY5e0nrVzIEvj7z";
var _2 = "HNb6UNGAK7kSDInm";
var _3 = "OYZEFdffZwg_nP9C";
var _4 = "eL3TH9PR8h07Xyhl";
export { _1 as "activeDot", _2 as "dot", _3 as "dotsHolder", _4 as "inactiveDot" }
// extracted by css-extract-rspack-plugin
var _1 = "NhY5e0nrVzIEvj7z";
var _2 = "HNb6UNGAK7kSDInm";
var _3 = "OYZEFdffZwg_nP9C";
var _4 = "eL3TH9PR8h07Xyhl";
export { _1 as "activeDot", _2 as "dot", _3 as "dotsHolder", _4 as "inactiveDot" }
